// Translate vertical mouse-wheel scrolling into horizontal scrolling when the
// pointer is over a horizontally-scrollable strip (slideover tab bars, the
// inbox thread actions bar, etc.). Windows mice have no horizontal scroll
// gesture and most of these strips hide their scrollbar (`scrollbar-hide`),
// so without this they cannot be scrolled at all on Windows.
//
// Rules:
// - Applies to the nearest scrollable ancestor of the wheel target. If that
//   ancestor scrolls vertically (e.g. a slideover body), nothing happens —
//   vertical scrolling is never hijacked.
// - Trackpad horizontal gestures (deltaX dominant) stay native.
// - Shift+wheel already scrolls horizontally in every browser — stays native.
// - The wheel is always consumed over a scrollable strip, including at its
//   ends — letting it chain would scroll the page BEHIND a slideover (the
//   strip's scroll chain bypasses the slideover body).

function findHorizontalScroller(start) {
  for (let el = start; el && el !== document.body; el = el.parentElement) {
    if (!(el instanceof Element)) return null
    const style = getComputedStyle(el)
    const scrollableY = (style.overflowY === 'auto' || style.overflowY === 'scroll') &&
      el.scrollHeight > el.clientHeight + 1
    if (scrollableY) return null
    const scrollableX = (style.overflowX === 'auto' || style.overflowX === 'scroll') &&
      el.scrollWidth > el.clientWidth + 1
    if (scrollableX) return el
  }
  return null
}

document.addEventListener('wheel', (event) => {
  if (event.shiftKey || event.ctrlKey) return
  if (Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return

  const scroller = findHorizontalScroller(event.target)
  if (!scroller) return

  // Firefox reports wheel deltas in lines (deltaMode 1) — normalise to pixels
  const delta = event.deltaMode === 1 ? event.deltaY * 16 : event.deltaY
  const max = scroller.scrollWidth - scroller.clientWidth

  event.preventDefault()
  scroller.scrollLeft = Math.max(0, Math.min(max, scroller.scrollLeft + delta))
}, { passive: false })
